import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { LoginStatusSelector } from 'src/app/app-store/login/login.selector';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ExternalLoginGuardGuard implements CanActivate {
  constructor(private store: Store, private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.store.pipe(select(LoginStatusSelector)).pipe(
      map(result => {
        if (result) {
          this.router.navigateByUrl('/');
          return false;
        } else {
          return true;
        }
      })
    );
  }

}
